import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateReviewCheckList } from 'redux/WellGuardian';
import { useCountryState } from 'redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { ChecklistQuestions, CountryData } from 'types/wellGuardian';

const EQUIPMENT_PROCUREMENT_UK_ID = 23;

const NUPRC_NG_ID = 2;

export const useChecklistData = () => {
  const dispatch = useDispatch();
  const [checklistQs, setChecklistQs] = useState<ChecklistQuestions | null>(null);
  const [checklistQsLoading, setChecklistQsLoading] = useState<boolean>(false);
  const countryState = useCountryState();

  const fetchChecklistData = useCallback(async () => {
    setChecklistQsLoading(true);
    const response = await wellGuardianApiClient.getChecklistQs(countryState);
    if (response?.generic && countryState !== CountryData.unitedKingdom) {
      let filterResponse = response?.generic.filter(
        list => list.check_id !== EQUIPMENT_PROCUREMENT_UK_ID,
      );

      if (countryState === CountryData.angola) {
        filterResponse = response?.generic.filter(list => list.check_id !== NUPRC_NG_ID);
      }

      setChecklistQs({ ...response, generic: filterResponse });
    } else {
      setChecklistQs(response);
    }
    dispatch(updateReviewCheckList(response));
    setChecklistQsLoading(false);
  }, [countryState, dispatch]);

  useEffect(() => {
    fetchChecklistData();
  }, [fetchChecklistData]);

  return {
    checklistQsLoading,
    checklistQs,
  };
};
